<template>
    <div class="wrapper">
      <div class="backNav desktop"></div>

      <ion-app>
        <!-- <Navbar :class="{desktop:isMobile}"/> -->
        <Navbar :class="{hideMe:!showHeader}"/>

          <!-- TRANSITION DESKTOP -->
          <transition name="fade">
            <router-view></router-view>
          </transition>
          <!-- TRANSITION DESKTOP -->


          <!-- TRANSITION MOBILE -->
          <transition name="slide">
            <router-view name="slideOut"></router-view>
          </transition>
          <!-- TRANSITION MOBILE -->


          <!-- WRAPPER SETTiNGS POPUP DESKTOP -->
          <div class="backMask" @click="showMenuSettings"  v-if="showMe"></div>
          <!-- WRAPPER SETTiNGS POPUP DESKTOP -->
          <Footer v-if="showFooter"></Footer>
      </ion-app>

    </div>
</template>



<script>
import Navbar from '../module/Navbar'
import AreasStore from '../AreasStore';
import CatMixin from './category/CatMixin'
import { mapGetters } from 'vuex'
import Footer from '../module/Footer'


export default {
  name:"admin",
  store:AreasStore,
    components:{
        Navbar,
        Footer
    }, 
  data(){
    return {
      showMe:false,
      showFooter:true,
      showHeader:true,
      isMobile:false,
    }
  }, 
  computed: {
    ...mapGetters([
      'getShowSettings',
      'getShowFooter',
      'getShowHeader',
        'getIsMobile'
    ])
  },     
  created (){
    this.showMe = this.getShowSettings;
    this.showFooter = this.getShowFooter;
    this.showHeader = this.getShowHeader;
    this.isMobile = this.getIsMobile;
    this.$store.dispatch('setIsMobile', this.isMobile);
    // console.log('########   ADMIN   #####')
    window.addEventListener('resize', this.resize);
  }, 
  mounted(){
    this.resize();
  },
  mixins: [
    CatMixin
  ],
  methods : {
    showMenuSettings(){
      this.$store.dispatch('showmenusettings',false)
    },
    resize(){
      if(window.innerWidth <= '992'){
        this.$store.dispatch('setIsMobile', true);
      }else{
        this.$store.dispatch('setIsMobile',false);
        this.$store.dispatch('showHeader', true);
      }
    }
  },
  watch: {
      getShowSettings() {
        this.showMe = this.getShowSettings;
      },
      getShowFooter() {
        this.showFooter = this.getShowFooter;
      },      
      getShowHeader() {
        this.showHeader = this.getShowHeader;
      },
    getIsMobile(){
        this.isMobile = this.getIsMobile;
    }
  }  
};
</script>
